module.exports = __webpack_public_path__ + "static/media/187.6c685abf.png";